import React, { Component, Fragment, ReactNode } from 'react'

export interface ListItem {
  key?: string
  value: string | number | ReactNode
  highlight?: boolean
}

interface ListProps {
  items: ListItem[]
}

export default class List extends Component<ListProps> {
  itemClassName (item: ListItem) {
    const base = 'mr-1'
    const bold = item.highlight && 'font-medium'
    return `${base} ${bold}`
  }

  key (item: ListItem) {
    const { key } = item
    const className = this.itemClassName(item)
    return key &&
      <span className={className}>
        {key}:
      </span>
  }

  item (item: ListItem) {
    const { value } = item
    if (value !== 0 && !value) return null
    return (
      <div className="flex leading-5">
        {this.key(item)}
        <span className="text-secondary truncate">
          {value}
        </span>
      </div>
    )
  }

  render () {
    return this.props.items.map((item, index) => (
      <Fragment key={index}>
        {this.item(item)}
      </Fragment>
    ))
  }
}
